export default [{
  path: '/agreement',
  name: 'agreement',
  component: () => import('./views/agreement'),
  meta: {
    title: '协议管理'
  }
}]
